export const apiErrorsTypes: any = {
  'user-exist': 'هذا الحساب قد تم استعماله من قبل، يرجى محاولة تسجيل الدخول به',
  'phone-exist': 'الرقم الهاتف التي ادخلته قد تم استعماله من قبل، يرجى محاولة تسجيل الدخول به او ادخال رقم هاتف مختلف',
  'user-not-found': 'لم يتم العثور على هذا الحساب، الرجاء التتأكد ومحاولة مره اخرى',
  'token-not-found': 'صلاحية لاعادة كلمة المرور قد اكتملت، يرجى اعادة الخطوات مرة اخرى',
  'invalid-token': 'صلاحية لاعادة كلمة المرور قد اكتملت، يرجى اعادة الخطوات مرة اخرى',
  'user-subscription-canceled': 'تم تعطيل الحساب، اذا حدث اي خطأ يرجى مراجعة الشركة بهذه المشكلة',
  'invalid-credentials': 'يوجد خطا في رمز المرور او البريد الاكتروني، الرجاء التتاكد ومحاولة مره ثانية',
  'user-role-invalid': 'نوعية هذه الحساب لا تسمحه بالدخول الى هذا النطاق',
  'passport-image-required': 'يرجى تحميل صورة جواز السفر لاكمال التسجيل',
  'passport-upload-failed': 'حدث خطأ اثناء رفع صورة جواز السفر، الرجاء المحاولة مرة اخرى',
  'order-note-too-long': 'الملاحظة طويلة جدا، الحد الاقصى 600 حرف',
  'order-theme-invalid': 'اللون الذي تم اختياره غير صالح، يرجى اختيار لون اخر'
}